import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IRootStyleProps } from './LoadingScreen.types';

export const RootStyle = styled(Box)<IRootStyleProps>(
  ({ theme, seeThrough }) => ({
    right: 0,
    bottom: 0,
    zIndex: 99999,
    width: '100%',
    height: '100%',
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: seeThrough
      ? 'transparent'
      : theme.palette.background.default,
  })
);
